module.exports = __webpack_public_path__ + "img/shili.8170364b.jpg";